<template>
  <v-list-item
    v-bind="$attrs"
    :class="selectedAppearance"
  >
    <v-list-item-action
      class="select-item__checkbox"
      @click.stop
    >
      <v-checkbox
        v-model="isSelected"
      />
    </v-list-item-action>

    <v-list-item-content class="select-item__text">
      <v-list-item-title>{{ item.text }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action
      v-if="item.hasIgnoreOption"
      @click.stop
    >
      <v-btn
        icon
        :color="ignoreButtonColor"
        @click.stop="ignoreTag"
      >
        <StIcon icon-name="cancel" />
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import StIcon from '@stilingue/st-icon';
import colors from '@/utils/colors';

export default {
  name: 'SelectItem',
  components: {
    StIcon,
  },
  inheritAttrs: true,
  props: {
    item: {
      type: Object,
      required: true,
    },
    itemAttributes: {
      type: Object,
      default() {
        return {
          'aria-selected': false,
        };
      },
    },
  },
  computed: {
    ignoreButtonColor() {
      if (this.item.shouldIgnore) {
        return colors.negativeColor;
      }

      if (this.item.shouldIgnore === false) {
        return colors.ui.steel;
      }

      return null;
    },
    isSelected: {
      get() {
        return this.itemAttributes['aria-selected'] === 'true' && this.item.shouldIgnore === false;
      },
      set() {
        this.$emit('consider-item', { item: { ...this.item } });
        return null;
      },
    },
    selectedAppearance() {
      return this.item.shouldIgnore ? 'select-item to-ignore' : 'select-item';
    },
  },
  methods: {
    ignoreTag() {
      this.$emit('ignore-item', {
        item: { ...this.item },
      });
    },
  },
};
</script>

<style scoped lang="scss">
  $st-color-scartet: rgba(255, 19, 0, 0.3);

  .select-item {
    padding: 0 var(--ds-spacing-stack-xs) !important;

    &__checkbox {
      margin: 18px 0;
    }

    &__text {
      width: 155px;
    }
  }

  .to-ignore {
    background-color: $st-color-scartet;
  }

  ::v-deep {
    .v-messages {
      display: none !important;
    }

    .v-input {
      &__slot {
        margin-top: 8px;
      }
    }

    .v-input--selection-controls__input i.theme--light {
      color: rgba(0, 0, 0, 0.54);
    }
  }
</style>
